export default __webpack_public_path__ + "static/media/kydmark.62e31cf2.svg";